import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

// @ts-ignore
import styles from './form.module.scss';

interface LightBoxProps {
  children: any,
  title: string
}

export default function LightBox(props: LightBoxProps) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className={styles.cursorZoomIn} onClick={() => handleShow()}>
        {props.children}
      </div>
      <Modal show={show} onHide={handleClose}>
        {props.title && (
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        )}
        <Modal.Body className="border-bottom">{props.children}</Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
